export const myStorage = (typeof window !== 'undefined' && window.localStorage) || {};

export const writeToStorage = (key, value) => {
    try {
        myStorage.setItem(key, value);
        return true;
    } catch (err) {
        return false;
    }
};

export const readFromStorage = (key) => {
    try {
        return JSON.parse(myStorage.getItem(key));
    } catch (err) {
        return null;
    }
};



// WEBPACK FOOTER //
// ./src/universal/utils/local-storage.js